/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Submit_Badge_Rule_DofollowInputs */

const en_directory_submit_badge_rule_dofollow = /** @type {(inputs: Directory_Submit_Badge_Rule_DofollowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`dofollow when a verified badge backlink is on your site.`)
};

const zh_directory_submit_badge_rule_dofollow = /** @type {(inputs: Directory_Submit_Badge_Rule_DofollowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`dofollow — 前提是你的网站上放置了已验证的徽章。`)
};

/**
* | output |
* | --- |
* | "dofollow when a verified badge backlink is on your site." |
*
* @param {Directory_Submit_Badge_Rule_DofollowInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_submit_badge_rule_dofollow = /** @type {((inputs?: Directory_Submit_Badge_Rule_DofollowInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Submit_Badge_Rule_DofollowInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_submit_badge_rule_dofollow(inputs)
	return zh_directory_submit_badge_rule_dofollow(inputs)
});
export { directory_submit_badge_rule_dofollow as "directory.submit.badge.rule_dofollow" }